import React from 'react';
import { IconDownload } from '@iwoca/icons';
import { Card, Link } from '@iwoca/orion';
import { usePhoneNumber } from 'hooks/usePhoneNumber';
import styles from './NoProducts.module.css';

type TStep = {
  id: number;
  title: React.ReactNode;
  content: React.ReactNode;
};

const STEPS: TStep[] = [
  {
    id: 1,
    title: (
      <h3 className={styles.stepHeading}>
        Bitte füllen Sie unseren{' '}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="https://static.iwoca.com/pdf/de/Partner-Fragebogen-v2.pdf"
        >
          Partner-Fragebogen
        </Link>{' '}
        aus und unterschreiben diesen
      </h3>
    ),
    content: (
      <p className={styles.stepContent}>
        (Auf Seite 4 des Fragebogens finden Sie eine Auflistung der benötigten
        Anlagen)
      </p>
    ),
  },
  {
    id: 2,
    title: (
      <h3 className={styles.stepHeading}>
        Speichern Sie folgende Dokumente für Ihre Unterlagen:
      </h3>
    ),
    content: (
      <>
        <Link
          className={styles.link}
          target="_blank"
          rel="noopener noreferrer"
          href="https://static.iwoca.com/pdf/de/iwoca_Partner_AGB_v20240816.pdf"
        >
          <IconDownload />
          AGBs Partner
        </Link>
        <Link
          className={styles.link}
          target="_blank"
          rel="noopener noreferrer"
          href="https://static.iwoca.com/pdf/de/Broker-60m-500k.pdf"
        >
          <IconDownload />
          Produktmerkblatt
        </Link>
      </>
    ),
  },
  {
    id: 3,
    title: (
      <h3 className={styles.stepHeading}>
        Schicken Sie die angeforderten Unterlagen an{' '}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="mailto:partner@iwoca.de"
        >
          partner@iwoca.de
        </Link>
      </h3>
    ),
    content: (
      <p className={styles.stepContent}>
        (Sobald wir Ihre Unterlagen erhalten und geprüft haben, können Sie das
        Partnerportal in vollem Umfang nutzen und Ihren ersten Antrag stellen)
      </p>
    ),
  },
];

// Only use with DE
export const NoProducts = () => {
  const { phoneNumberLink, phoneNumber } = usePhoneNumber();

  return (
    <div className={styles.container}>
      <div className={styles.contents}>
        <h1 className={styles.heading}>
          Herzlich Willkommen im iwoca Partnerportal!
        </h1>
        <p className={styles.headingDescription}>
          Wir freuen uns auf eine erfolgreiche Zusammenarbeit mit Ihnen! Um
          diese zu beginnen, befolgen Sie bitte die nächsten Schritte:
        </p>
        <Card className={styles.card}>
          <ul className={styles.stepsContainer}>
            {STEPS.map((step) => (
              <li className={styles.stepItem} key={step.id}>
                <div className={styles.stepNumberContainer}>
                  <div className={styles.stepNumber}>{step.id}</div>
                </div>
                <div className={styles.stepContentContainer}>
                  {step.title}
                  {step.content}
                </div>
              </li>
            ))}
          </ul>
        </Card>
        <hr className={styles.divider} />
        <div className={styles.footer}>
          <h2 className={styles.footerHeading}>Sie benötigen Hilfe?</h2>
          <p className={styles.footerContent}>
            Sollten Sie Fragen haben, können Sie sich gerne jederzeit unter{' '}
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href={`tel:${phoneNumberLink}`}
            >
              {phoneNumber}
            </Link>{' '}
            bei uns melden.
          </p>
        </div>
      </div>
    </div>
  );
};
